import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import MainLayout from './components/MainLayout';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import CreateListingPage from './pages/CreateListingPage';
import ListingsPage from './pages/ListingsPage';
import ListingDetailPage from './pages/ListingDetailPage';
import DashboardPage from './pages/DashboardPage';
import FakeBankGateway from './pages/FakeBankGateway';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ValuationPage from './pages/ValuationPage';
import ArticlesPage from './pages/ArticlesPage';
import DynamicPageViewer from './pages/DynamicPageViewer';
import EducationalPage from './pages/EducationalPage';
import AdminContentPage from './pages/AdminContentPage';
import AdminValuationRequestsPage from './pages/AdminValuationRequestsPage';
import AdminListingTypesSettingsPage from './pages/AdminListingTypesSettingsPage';
import ContactPage from './pages/ContactPage';
import PaymentResultPage from './pages/PaymentResultPage';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<HomePage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="valuation" element={<ValuationPage />} />
        <Route path="articles" element={<ArticlesPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="listings" element={<ListingsPage />} />
        <Route path="listings/:id" element={<ListingDetailPage />} />
        
        {/* Dynamic Pages Route */}
        <Route path="pages/:slug" element={<DynamicPageViewer />} />
        <Route path="help/:slug" element={<EducationalPage />} />
        <Route path="admin/content" element={<AdminContentPage />} />
        <Route path="admin/valuation-requests" element={
          <ProtectedRoute>
            <AdminValuationRequestsPage />
          </ProtectedRoute>
        } />
        <Route path="admin/listing-types" element={
          <ProtectedRoute>
            <AdminListingTypesSettingsPage />
          </ProtectedRoute>
        } />
        
        <Route path="create-listing" element={
          <ProtectedRoute>
            <CreateListingPage />
          </ProtectedRoute>
        } />
        
        <Route path="listings/edit/:id" element={
          <ProtectedRoute>
            <CreateListingPage />
          </ProtectedRoute>
        } />
        
        <Route path="dashboard" element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } />

        <Route path="profile" element={
          <ProtectedRoute>
            <Navigate to="/dashboard" replace />
          </ProtectedRoute>
        } />
        
        <Route path="payment-result" element={<PaymentResultPage />} />
      </Route>
      
      <Route path="/fake-gateway" element={<FakeBankGateway />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <HashRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </HashRouter>
  );
};

export default App;
